'use strict';

angular.module('pulianiBookStoreApp')
	.directive('bookTpl', function (Global, Auth, toaster, mywishlist, MyCart) {
		return {
			templateUrl: 'components/directives/BookTpl/BookTpl.html',
			restrict: 'E',
			scope: {
				book: '=',
				isfromlanding: '='
			},
			controller: function ($scope, $rootScope) {
				$scope.currencyType = Global.CURRENCY;
				function getExtension(filename) {

					var indexoflastDot = filename.lastIndexOf('.');
					return (indexoflastDot < 0) ? '' : filename.substr(indexoflastDot);
				}

				//Get path without extension
				function getPathWithoutExtension(filename) {

					var indexoflastDot = filename.lastIndexOf('.');
					return (indexoflastDot < 0) ? '' : filename.substr(0, indexoflastDot);
				}

				//Get thumbnail image from origional image pathoflastDot
				$scope.getMediumImage = function (image) {

					return getPathWithoutExtension(image) + '_medium' + getExtension(image).toLowerCase();
				}


				$scope.onAddToWishList = function (productid) {

					mywishlist.AddToUserWishList({ product_id: productid })

						.then(function (data) {

							toaster.pop("info", "Item added to wishlist");
						})

						.catch(function (error) {

							if (error && error.errorTitle === 'Login required') {
								$scope.$emit('openLoginModal');

							} else {

								toaster.pop("error", "Product is already added to wishlist!");
							}

							//toaster.pop("warning",error.errorTitle,error.errorDesc);
						});
				}


				$scope.onCartAdd = function (productid, quantity, unitsInStock) {

					MyCart.addToCart(productid, quantity, unitsInStock).then(function (data) {
						flytocart(productid, $rootScope.isfromlanding);
						$scope.$emit('checkCartShell');
						//toaster.pop("info","Item added to cart");
					},
						function (err) {
							if (err.data) {
								if (err.data.message)
									toaster.pop("warning", err.data.message);
								else
									toaster.pop("warning", err.data);
							}
						});

				}


				function flytocart(id, isfromlanding) {

					var cartElem = angular.element(document.getElementsByClassName("shopping-cart"));
					//console.log("bounds",cartElem.offset());
					var offsetTopCart = cartElem.offset().top;
					var offsetLeftCart = cartElem.offset().left;
					var widthCart = cartElem.prop('offsetWidth');
					var heightCart = cartElem.prop('offsetHeight');
					//console.log("offsetTopCart:"+offsetTopCart+";offsetLeftCart:"+offsetLeftCart+";widthCart:"+widthCart+";heightCart"+heightCart);
					//var imgElem = angular.element(event.target.parentNode.parentNode.parentNode.childNodes[3].childNodes[1].childNodes[2].childNodes[2].childNodes[1]);
					var imgElem = angular.element(document.getElementById("bookTplImg_" + id));
					//console.log("ELEM",angular.element(event.target.parentNode.parentNode.parentNode.childNodes[3].childNodes[1].childNodes[2].childNodes[2].childNodes[1]));
					if ($scope.isfromlanding) {
						var posPar = angular.element(document.getElementById("parentElm_" + id));
						$('#flyingcontainer').css({ 'top': posPar.offset().top, 'left': posPar.offset().left, width: '150px', height: '150px' });
						var parentElem = angular.element(document.getElementById("flyingcontainer"));
					}
					else
						var parentElem = angular.element(document.getElementById("parentElm_" + id));
					console.log("parentElem", parentElem);
					var offsetLeft = imgElem.prop("offsetLeft");
					var offsetTop = imgElem.prop("offsetTop");
					var imgSrc = imgElem.prop("currentSrc");
					console.log(offsetLeft + ' ' + offsetTop + ' ' + imgSrc);
					console.log(imgElem.offset().top + ' ' + imgElem.offset().left);
					var imgClone = angular.element('<img src="' + imgSrc + '"/>');
					imgClone.css({
						'height': '150px',
						'position': 'absolute',
						'top': offsetTop + 'px',
						'left': offsetLeft + 'px',
						'opacity': 0.5,
						'overflow': 'visible',
						'zIndex': 9999
					});
					imgClone.addClass('itemaddedanimate');
					console.log("calcPix", offsetLeftCart - imgElem.offset().left);
					parentElem.append(imgClone);
					setTimeout(function () {
						imgClone.css({
							'height': '75px',
							'top': (offsetTopCart - imgElem.offset().top + heightCart / 2) + 'px',
							'left': (offsetLeftCart - imgElem.offset().left + widthCart / 2) + 'px',
							'opacity': 0.5,
							'overflow': 'visible',
							'zIndex': 9999
						});
					}, 500);
					setTimeout(function () {
						imgClone.css({
							'height': 0,
							'opacity': 0.5,
							'overflow': 'visible',
							'zIndex': 9999

						});
						cartElem.addClass('shakeit');
					}, 2000);
					setTimeout(function () {
						cartElem.removeClass('shakeit');
						imgClone.remove();

						if ($scope.isfromlanding)
							$('#flyingcontainer').css({ width: '1px', height: '1px' });

					}, 2500);

				}

				$scope.onPriceRequest = function (productid, productname) {
					




				}



			}
		};
	});
